const Vue = require('vue')

Vue.component('ui-inline-modal', require('components/ui/InlineModal.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/inline-modal.js